"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealVersionStampSchema = void 0;
exports.dealVersionStamp = dealVersionStamp;
const zod_1 = require("zod");
/**
 * SNAPSHOTTED, NEVER JOINED (spec V5) — the same discipline as employee
 * attribution in the order-journey backbone. Two fields on six records is what
 * turns every version-wise report into a group-by instead of archaeology.
 *
 * A stamp added later leaves every record before it unattributable forever,
 * which is why all six sites are one task rather than an afterthought.
 */
exports.DealVersionStampSchema = zod_1.z.object({
    dealId: zod_1.z.string().min(1),
    dealVersionNo: zod_1.z.number().int().positive(),
});
function dealVersionStamp(dealId, versionNo) {
    return { dealId, dealVersionNo: versionNo };
}
//# sourceMappingURL=dealVersionStamp.js.map